import React from 'react';
import PropTypes from 'prop-types';
import MiniDetails from 'app/commonComponents/miniDetails/miniDetails';
import MiniCartIcon from './miniCartIcon/miniCartIconContainer';
import ExchangeMessage from './exchangeMessage/exchangeMessageContainer';
import MiniCartSummary from './miniCartSummary/miniCartSummaryContainer';
import MiniCartProducts from './miniCartProducts/miniCartProductsContainer';
import MiniCartOptions from './miniCartOptions/miniCartOptionsContainer';
import MiniCartHeader from './miniCartHeader/miniCartHeader';

const MiniCartApp = ({
  isOpened,
  setMiniDetailsWrapperRef,
  miniRef,
  closeOrRedirect,
  openOrRedirect,
  keyboardToggle,
  cmsComponents,
  backdrop,
  miniType,
  baseUrl,
}) => (
  <div className="nav__btn-wrapper" ref={miniRef}>
    <ExchangeMessage />
    <MiniCartIcon
      miniType={miniType}
      isOpened={isOpened}
      openOrRedirect={openOrRedirect}
      keyboardToggle={keyboardToggle}
      baseUrl={baseUrl}
    />
    {isOpened && (
      <MiniDetails backdrop={backdrop} setMiniDetailsWrapperRef={setMiniDetailsWrapperRef}>
        <MiniCartHeader miniType={miniType} />
        <MiniCartProducts shoppingList={cmsComponents.shoppingList} />
        <MiniCartSummary closeOrRedirect={closeOrRedirect} />
        <MiniCartOptions
          miniType={miniType}
          retrieveBag={cmsComponents.retrieveBag}
          closeOrRedirect={closeOrRedirect}
        />
      </MiniDetails>
    )}
  </div>
);

MiniCartApp.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  miniRef: PropTypes.objectOf(PropTypes.object).isRequired,
  miniType: PropTypes.string.isRequired,
  cmsComponents: PropTypes.objectOf(PropTypes.instanceOf(Element)).isRequired,
  setMiniDetailsWrapperRef: PropTypes.func.isRequired,
  closeOrRedirect: PropTypes.func.isRequired,
  openOrRedirect: PropTypes.func.isRequired,
  keyboardToggle: PropTypes.func.isRequired,
  backdrop: PropTypes.objectOf(PropTypes.object).isRequired,
  baseUrl: PropTypes.string.isRequired,
};

export default MiniCartApp;
